import { serialize } from 'object-to-formdata';
import { ICompanyForm, ICompanyPatchResponse } from 'types/forms/company';
import {
  ICompanyResponse,
  ICompaniesResponse,
  ICompanyContactAndSupportsResponse,
  ICompanyContactAndSupportResponse,
  IContactAndSupportCreateRequest,
  IContactAndSupportUpdateRequest
} from 'types/company';
import request from './index';

export const getPartnerCompanies = () =>
  request<ICompaniesResponse>({
    options: {
      url: '/partner_companies',
      method: 'get'
    }
  });

export const getPartnerCompany = (id: string) =>
  request<ICompanyResponse>({
    options: {
      url: `/partner_companies/${id}`,
      method: 'get'
    }
  });

export const getMainCompany = () =>
  request<ICompanyResponse>({
    options: {
      url: '/company/main',
      method: 'get'
    }
  });

export const createPartnerCompany = (data: ICompanyForm) =>
  request<ICompanyPatchResponse>({
    options: {
      url: '/partner_companies',
      method: 'post',
      data: serialize(data, { allowEmptyArrays: true })
    },
    headers: { 'Content-Type': 'multipart/form-data' }
  });

export const editPartnerCompany = (id: string, data: ICompanyForm) =>
  request<ICompanyPatchResponse>({
    options: {
      url: `/partner_companies/${id}`,
      method: 'patch',
      data: serialize(data, { allowEmptyArrays: true })
    },
    headers: { 'Content-Type': 'multipart/form-data' }
  });

export const editMainCompany = (data: ICompanyForm) =>
  request<ICompanyPatchResponse>({
    options: {
      url: '/company/main',
      method: 'patch',
      data: serialize(data, { allowEmptyArrays: true })
    },
    headers: { 'Content-Type': 'multipart/form-data' }
  });

/** PATCH tylko pól ustawień (języki, sesja, flagi) – wysyłane jako JSON dla poprawnych typów. */
export const patchMainCompanySettings = (
  payload: {
    company: Partial<{
      email_domain: string;
      user_code: string;
      default_language_code: string | null;
      available_language_codes: string[];
      id_locale: string | null;
      date_format: string | null;
      currency: string | null;
      currency_symbol: string | null;
      decimal_separator: string | null;
      thousands_separator: string | null;
      first_day_of_week: string | null;
      measurement_units: string | null;
      session_duration_minutes: number | null;
      use_only_company_emails: boolean;
      use_second_name: boolean;
    }>;
  }
) =>
  request<ICompanyPatchResponse>({
    options: {
      url: '/company/main',
      method: 'patch',
      data: payload
    }
  });

export const deletePartnerCompany = (id: string) =>
  request({
    options: {
      url: `/partner_companies/${id}`,
      method: 'delete'
    }
  });

export const getCompanyContactAndSupports = (companyId: string) =>
  request<ICompanyContactAndSupportsResponse>({
    options: {
      url: `/companies/${companyId}/contact_and_supports`,
      method: 'get'
    }
  });

export const createContactAndSupport = (
  companyId: string,
  data: IContactAndSupportCreateRequest
) =>
  request<ICompanyContactAndSupportResponse>({
    options: {
      url: `/companies/${companyId}/contact_and_supports`,
      method: 'post',
      data
    }
  });

export const updateContactAndSupport = (
  companyId: string,
  id: number,
  data: IContactAndSupportUpdateRequest
) =>
  request<ICompanyContactAndSupportResponse>({
    options: {
      url: `/companies/${companyId}/contact_and_supports/${id}`,
      method: 'patch',
      data
    }
  });

export const deleteContactAndSupport = (companyId: string, id: number) =>
  request<void>({
    options: {
      url: `/companies/${companyId}/contact_and_supports/${id}`,
      method: 'delete'
    }
  });
